import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  LinearProgress,
} from '@material-ui/core';
import Auth0LockService from '../../../services/AuthService/Auth0LockService';
import logo from '../../../images/icon.png';
import styles from './styles';

const LoadingPage = ({ classes }) => {
  Auth0LockService.getLock();
  return (
    <div className={classes.loadingContainer}>
      <div className={classes.imageContainer}>
        <img src={logo} alt="Pingum" className={classes.logo} />
        <LinearProgress />
      </div>
    </div>
  );
};

LoadingPage.propTypes = { classes: PropTypes.object };

LoadingPage.defaultProps = { classes: {} };

export default withStyles(styles)(LoadingPage);
